import React from 'react';
import './ModemDetails.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';

import Pressure from "../../assets/images/pressure_sensor.png"

const PRESSURE_SPEC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="spec-container">
      <div className="spec-header-image">
        <img src={Pressure} className="spec-header-image-img" />
      </div>

      <div className="spec-item full-widtli>h">
        <h2 className="spec-title">{t('accessoires.pressure.details.title')}</h2>
        <ul className="spec-details">
          <li>{t('accessoires.pressure.details.p1')}</li>
          <li>{t('accessoires.pressure.details.p2')}</li>
          <li>{t('accessoires.pressure.details.p3')}</li>
          <li>{t('accessoires.pressure.details.p4')}</li>
        </ul>
      </div>

    </div>
  );
};

export default PRESSURE_SPEC;
